"use strict";
/**
 * Делает побитовое & для чисел в строках
 *
 * @param bitsum первое число
 * @param child второе число
 */var isChildBitwiseForStrings=function(r,e){if(!r||!e||r.length<e.length)return!1;for(var i=r.split("").reverse(),t=e.split("").reverse(),s=t.indexOf("1");-1!==s;){if("1"!==i[s])return!1;s=t.indexOf("1",s+1)}return!0};module.exports=isChildBitwiseForStrings;
